<script setup lang="ts">
import { useDevice } from '@absolutins/ui-kit'
import { computed } from 'vue'

const { isMobile } = useDevice()

const logoPath = computed(() => (isMobile.value ? '/images/logo-mobile.svg' : '/images/logo.svg'))
</script>

<template>
  <a
    class="the-logo"
    href="https://www.absolutins.ru/"
    aria-label="Логотип"
  >
    <img
      :src="logoPath"
      alt="Логотип"
      loading="lazy"
    />
  </a>
</template>

<style scoped lang="scss">
.the-logo {
  display: inline-flex;

  img {
    display: block;
    width: 58px;
    height: 42px;

    @include media-tablet {
      width: 188px;
    }
  }
}
</style>
